import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { BillingDocumentsFacade } from '../../../../../Facades/Billing/billing-documents.facade';
import { DATE_TIME_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { DunningStateResponse } from '../../../../../Interfaces/api/backoffice/billing-document.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'av-dunning-panel',
  standalone: true,
  imports: [DatePipe, MatIconModule, AvStatusChipComponent, TranslateModule],
  templateUrl: './dunning-panel.component.html',
  styleUrl: './dunning-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class DunningPanelComponent {
  readonly facade = inject(BillingDocumentsFacade);

  readonly dateTimeFormat = DATE_TIME_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;

  readonly dunning = computed<DunningStateResponse | null>(
    () => this.facade.attention()?.dunning ?? null,
  );

  readonly hasLadder = computed<boolean>(() => (this.dunning()?.first_failed_at ?? null) !== null);
}
